import { render } from "./HeaderSearch.vue?vue&type=template&id=670efa6e"
import script from "./HeaderSearch.vue?vue&type=script&lang=js"
export * from "./HeaderSearch.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__